import MobileHeader from "../../../layout/DriverLayout/Header";
import { Typography } from "@mui/material";

import FreightsList from "./FreightsList";

export default function GetFreight() {
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            انتخاب بار{" "}
          </Typography>
        }
      />
      {/* <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    > */}
      {/* <Box
        sx={{
          borderColor: blueGrey[100],
          borderWidth: "1px",
          borderStyle: "solid",
          padding: "14px",
          backgroundColor: "bgColor.white",
          borderRadius: "10px",
        }}
      >
        <InfoBox />
        <SearchBox
          origin={searchBoxFormik.values.origin}
          destination={searchBoxFormik.values.destination}
        />
      </Box> */}
      {/* <NotifSwitch /> */}
      <FreightsList />
      {/* </Box> */}
    </>
  );
}
